import articleDefaultImg from "../../assets/images/article_default_img.png";
import style from "./ArticleList.module.css";
import "./Article.css";
import { Pagination } from "antd";
import request from "../../common/request";
import { Link, useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";

export default function Main({ catid }) {
  const { id } = useParams();
  const ref = useRef();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(10);
  const [list, setList] = useState([]);

  console.log(catid);

  useEffect(() => {
    request.getArticleList(catid, page, pageSize).then(function (result) {
      console.log(result);

      setList(result.data.data.data);
      setTotal(result.data.data.total);
    });
  }, [page, pageSize]);

  return (
    <>
      <div>
        {list.map((item, index) => (
          <div className={style.listRow} key={index}>
            <img src={item.img ? item.img : articleDefaultImg} />
            <h3>
              {item.title}
              <span>{item.created_at}</span>
            </h3>
            <p>{item.desc}</p>
            <Link to={"/article/" + item.id}> 阅读全文 >> </Link>
          </div>
        ))}

        {/* <div className={style.listRow}>
          <img src={articleDefaultImg} />
          <h3>银保监会印发融资担保监管补充规定：住房置业担保公司纳入监管  <span>2021-12-11 09:09:09</span></h3>
          <p>现有法规相衔接，坚持从严监管，要求融资担保公司监督管理部门承担主体监管责任，将未取得融资担保业务经营许可证但实际上经营融资担保业务的住房置业担保公司、信用增进公司等机构纳入监管，结合实际分类处置，推进牌照管理工作，妥善结清不持牌机构的存量业务，有利于进一步规范融资担保经营行为，促进融资担保行业稳健运行，更好支持普惠金融发展。</p>
          <Link to="/article/1"> 阅读全文 >> </Link>
        </div>
        <div className={style.listRow}>
          <img src={articleDefaultImg} />
          <h3>银保监会印发融资担保监管补充规定：住房置业担保公司纳入监管  <span>2021-12-11 09:09:09</span></h3>
          <p>现有法规相衔接，坚持从严监管，要求融资担保公司监督管理部门承担主体监管责任，将未取得融资担保业务经营许可证但实际上经营融资担保业务的住房置业担保公司、信用增进公司等机构纳入监管，结合实际分类处置，推进牌照管理工作，妥善结清不持牌机构的存量业务，有利于进一步规范融资担保经营行为，促进融资担保行业稳健运行，更好支持普惠金融发展。</p>
          <a> 阅读全文 >> </a>
        </div>
        <div className={style.listRow}>
          <img src={articleDefaultImg} />
          <h3>银保监会印发融资担保监管补充规定：住房置业担保公司纳入监管  <span>2021-12-11 09:09:09</span></h3>
          <p>现有法规相衔接，坚持从严监管，要求融资担保公司监督管理部门承担主体监管责任，将未取得融资担保业务经营许可证但实际上经营融资担保业务的住房置业担保公司、信用增进公司等机构纳入监管，结合实际分类处置，推进牌照管理工作，妥善结清不持牌机构的存量业务，有利于进一步规范融资担保经营行为，促进融资担保行业稳健运行，更好支持普惠金融发展。</p>
          <a> 阅读全文 >> </a>
        </div> */}
      </div>
      <Pagination
        defaultCurrent={page}
        total={total}
        pageSize={pageSize}
        onChange={(page, pageSize2) => {
          console.log("12312312", page, pageSize2);
          setPage(page);
          setPageSize(pageSize2);
        }}
        style={{ margin: "30px auto", textAlign: "center" }}
      />
    </>
  );
}
